<template>
  <div class="title">
    <p>{{ lang('积分兑换物料') }}</p>
    <!--    <div class="moreBox">-->
    <!--      <p class="more">更多</p>-->
    <!--      <img src="../../../assets/images/score/more.png" />-->
    <!--    </div>-->
  </div>
</template>

<script lang="ts" setup>
import lang from '@/langs'
</script>

<style scoped lang="less">
.title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  > p {
    color: #3c3c3c;
    font-size: 18px;
    font-weight: bold;
  }
  .moreBox {
    display: flex;
    flex-direction: row;
    align-items: center;
    .more {
      color: rgba(153, 153, 153, 1);
      font-size: 13px;
      font-weight: 400;
    }
    > img {
      width: 12px;
      height: 12px;
    }
  }
}
</style>
